import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  Customer,
  LocationProducts,
  OnBoardingRecord,
  ServiceAndLocation,
  StepInfo,
} from '@voice/utils';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientOnboardingService {
  constructor(private readonly httpClient: HttpClient) {}

  save(
    domain: string,
    customer: Customer,
    onBoardingId?: number
  ): Observable<unknown> {
    let url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records`;
    if (onBoardingId) {
      url += `/${onBoardingId}/customer`;
      return this.httpClient.patch(url, customer);
    } else {
      const payload = { domain, customer };
      return this.httpClient.post(url, payload);
    }
  }

  saveSteps(onBoardingId: number, steps: StepInfo[]): Observable<unknown> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${onBoardingId}/steps`;
    return this.httpClient.patch(url, steps);
  }

  saveLocations(
    onBoardingId: number,
    locations: ServiceAndLocation[]
  ): Observable<unknown> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${onBoardingId}/locations`;
    return this.httpClient.patch(url, locations);
  }

  saveProducts(onBoardingId: number, items?: LocationProducts[]) {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${onBoardingId}/products`;
    return this.httpClient.patch(url, items);
  }

  fetch(status: string): Observable<OnBoardingRecord[]> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records?status=${status}`;
    return this.httpClient.get<OnBoardingRecord[]>(url);
  }

  find(id: number): Observable<OnBoardingRecord> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}`;
    return this.httpClient.get<OnBoardingRecord>(url);
  }

  delete(id: number): Observable<void> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}`;
    return this.httpClient.delete<void>(url);
  }

  sendToRevio(id: number): Observable<any> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}/send`;
    return this.httpClient.post<any>(url, {});
  }

  sendCustomersAndSites(id: number): Observable<any> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}/send-customers`;
    return this.httpClient.post<any>(url, {});
  }

  sendItems(id: number): Observable<any> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}/send-items`;
    return this.httpClient.post<any>(url, {});
  }

  sendMissingLocations(id: number): Observable<any> {
    const url = `${environment.voiceAPIConfig.uri}/billing/client-onboarding/records/${id}/send-missing-locations`;
    return this.httpClient.post<any>(url, {});
  }
}
